import { ITabItem } from 'components/tab';
import React from 'react';
import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import FilterParametersContainer from './FilterParametersContainer';
import { FilterViews } from '../constants';
import FiltersPanel from './FiltersPanel';
import { IFilterDTO } from 'business/models/Models';

interface Props {
  contentView: FilterViews;
  selectedFilters: IFilterDTO[];
  setContentViewState: React.Dispatch<React.SetStateAction<FilterViews>>;
  setSelectedFilters: React.Dispatch<React.SetStateAction<IFilterDTO[]>>;
}
const FilterParametersPanel = (props: Props) => {
  const { setContentViewState, contentView, selectedFilters, setSelectedFilters } = props;
  const tabItems_: ITabItem[] = [
    {
      content: (
        <FilterParametersContainer
          setContentViewState={setContentViewState}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      ),
      title: 'Add Filter Parameters',
    },
  ];

  return (
    <div id="filterparameterspanel-wrapper" className="h-full overflow-y-auto">
      {contentView === FilterViews.PARAMETER_SELECTION && (
        <BaseSidePanel tabItems={tabItems_} headerTitle={'Add Filter Parameters'} />
      )}
      {contentView === FilterViews.SELECTED_PARAMETERS && (
        <FiltersPanel setContentViewState={setContentViewState} />
      )}
    </div>
  );
};

export default FilterParametersPanel;
